import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = (theme: ExactTheme) => css`
  position: relative;
  padding-top: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const closeBtnContainer = css`
  width: 50px;
  height: 56px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 2;
`;

export const closeBtn = css`
  cursor: "pointer";
`;

export const carouselThumb = css`
  display: flex;
  justify-content: center;
  height: 169px;
`;

export const sliderSection = css`
  position: relative;
  flex-shrink: 0;
`;

export const arrowLeftContainer = css`
  position: absolute;
  display: flex;
  align-items: center;

  left: 0;
  top: 0;
  bottom: 0;
  padding: 10px;
  z-index: 1;
  cursor: pointer;
`;

export const arrowRightContainer = css`
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  bottom: 0;
  right: 0;

  padding: 10px;
  z-index: 1;
  cursor: pointer;
`;

export const tabsSection = css`
  margin-top: 10px;
  flex-grow: 1;
`;

export const dotsContainer = css`
  .use-spring-carousel-thumbs-wrapper {
    column-gap: 4px;
    //max-width: 80px;
    justify-content: center;
    overflow: hidden !important;
  }
`;

export const image = ({
  src,
  isPlaceholder,
}: {
  src: string;
  isPlaceholder: boolean;
}) => css`
  background-image: url("${src}");
  background-size: ${isPlaceholder ? "100px 100px" : "contain"};
  background-repeat: no-repeat;
  background-position: center;
  height: 169px;
  cursor: pointer;
`;

export const dot =
  ({ isActive }: { isActive: boolean }) =>
  (theme: ExactTheme) => css`
    position: relative;

    width: 14px;
    cursor: pointer;
    height: 14px;

    :after {
      content: "";
      position: absolute;
      width: 8px;
      height: 8px;
      top: 50%;
      background-color: ${isActive
        ? theme.colorsV2.blue[500]
        : theme.colorsV2.grey[200]};
      left: 50%;
      transform-origin: center;
      transform: translate(-50%, -50%);
      border-radius: 100%;
    }
  `;

export const descriptionSection = css({
  marginTop: "20px",
});

export const descriptionText = css({
  marginTop: "5px",
});

export const tabContent = css`
  padding: 20px 10px;
`;

export const footer = css`
  padding: 25px;
  flex-shrink: 0;
`;

export const fullDescription = (theme: ExactTheme) => css`
  font-size: ${theme.fontSizesV2.body};
  h2:first-child,
  h1:first-child {
    margin-top: 0;
  }

  li {
    margin-top: 10px;
  }
`;
